import { Doc } from "@/components/Doc/Doc";
import { LabelExplainer } from "@/components/LabelExplainer/LabelExplainer";
import { ComputedResult } from "@/components/_pages/ModelPage/Sidebar/ComputedResult";
import { InputToggle } from "@/components/_pages/ModelPage/Sidebar/InputToggle";
import {
  isConventionalLoanTypeAtom,
  isRollinDealExpensesAtom,
  isRollinLoanTransactionFeeAtom,
  isRollinSBAGuarantyFeeAtom,
  sbaLoanTotalWithOptionalFeesAtom,
} from "@/financeModels/owasco/general";
import { lazyReactFallback } from "@/utils/lazy";
import { formatMoney } from "@/utils/moneyFormating";
import { useAtom, useAtomValue } from "jotai";
import { ChangeEvent } from "react";

const Sba7aLoanRollInLoanTransactionFeeExplainer = lazyReactFallback(
  () =>
    import("@/docs/pages/model/sidebar/sba7aLoanRollInLoanTransactionFee.mdx"),
);
const Sba7aLoanRollinSBAGuarantyFeeExplainer = lazyReactFallback(
  () => import("@/docs/pages/model/sidebar/sba7aLoanRollinSBAGuarantyFee.mdx"),
);

const Sba7aLoanRollinDealExpensesExplainer = lazyReactFallback(
  () => import("@/docs/pages/model/sidebar/sba7aLoanRollinDealExpenses.mdx"),
);

export const DealFees = () => {
  const isConventionalLoanType = useAtomValue(isConventionalLoanTypeAtom);

  const [isRollinLoanTransactionFee, setRollinLoanTransactionFee] = useAtom(
    isRollinLoanTransactionFeeAtom,
  );
  const [isRollinSBAGuarantyFee, setRollinSBAGuarantyFee] = useAtom(
    isRollinSBAGuarantyFeeAtom,
  );

  const [isRollinDealExpenses, setRollinDealExpenses] = useAtom(
    isRollinDealExpensesAtom,
  );

  const sbaLoanTotalWithOptionalFees = useAtomValue(
    sbaLoanTotalWithOptionalFeesAtom,
  );

  return (
    <>
      <InputToggle
        label={
          <LabelExplainer
            label="Roll-in Loan Transation Fee"
            explanation={<Sba7aLoanRollInLoanTransactionFeeExplainer />}
          />
        }
        checked={isRollinLoanTransactionFee}
        onChange={(event) =>
          setRollinLoanTransactionFee(
            (event as ChangeEvent<HTMLInputElement>).currentTarget.checked,
          )
        }
      />
      {!isConventionalLoanType && (
        <>
          <InputToggle
            label={
              <LabelExplainer
                label="Roll-in SBA's Guaranty Fee"
                explanation={<Sba7aLoanRollinSBAGuarantyFeeExplainer />}
              />
            }
            checked={isRollinSBAGuarantyFee}
            onChange={(event) =>
              setRollinSBAGuarantyFee(
                (event as ChangeEvent<HTMLInputElement>).currentTarget.checked,
              )
            }
          />
        </>
      )}
      <InputToggle
        label={
          <LabelExplainer
            label="Roll-in Deal Expenses"
            explanation={<Sba7aLoanRollinDealExpensesExplainer />}
          />
        }
        checked={isRollinDealExpenses}
        onChange={(event) =>
          setRollinDealExpenses(
            (event as ChangeEvent<HTMLInputElement>).currentTarget.checked,
          )
        }
      />
      <ComputedResult
        label={
          <LabelExplainer
            label={
              isConventionalLoanType
                ? "Senior Debt Total"
                : "SBA 7(a) Loan Total"
            }
            explanation={
              <Doc path="@/docs/pages/model/sidebar/sba7aLoanTotal.mdx" />
            }
          />
        }
        value={formatMoney(sbaLoanTotalWithOptionalFees)}
      />
    </>
  );
};
